import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth, StyledFlex, TextView } from '@dreryk/react-components';
import {
   dateTimeMinuteFormatter,
   patientNameFormatter,
   practitionerNameFormatter,
   Translate,
} from '@dreryk/react-common';

import { systemActivityTranslationKeys } from '../../../../translations';
import { ConfidentialResourceAccessRequestPending } from '../../../confidentialResourceAccessRequest.utils';

import { ReviewRequestForm } from './form/ReviewRequestForm';
import { ReviewRequestAcceptButton } from './ReviewRequestAcceptButton';
import { ReviewRequestRejectButton } from './ReviewRequestRejectButton';

type ReviewRequestModalProps = {
   request: ConfidentialResourceAccessRequestPending;
   onClose: VoidFunction;
};

export const ReviewRequestModal = (props: ReviewRequestModalProps): ReactElement => {
   const { request } = props;
   const [confidentialResource] = request.confidentialResources;

   return (
      <Modal
         title={systemActivityTranslationKeys.considerConfidentialDataRequest}
         width={ModalWidth.NORMAL}
         testId={'reviewRequest'}
      >
         <StyledFlex direction={'column'} gap={'16px'}>
            <TextView testId={'grantee'} label={systemActivityTranslationKeys.requestingPractitioner}>
               {practitionerNameFormatter(request.grantee)}
            </TextView>
            <TextView testId={'createdAt'} label={systemActivityTranslationKeys.requestSentDateLabel}>
               {dateTimeMinuteFormatter(request.createdAt)}
            </TextView>
            <TextView testId={'resourceType'} label={systemActivityTranslationKeys.dataSubject}>
               <Translate>{systemActivityTranslationKeys.resourceTypeMap[request.resourceType]}</Translate>
               {` (${dateTimeMinuteFormatter(confidentialResource.creationDate)})`}
            </TextView>
            <TextView testId={'patient'} label={systemActivityTranslationKeys.patient}>
               {patientNameFormatter(request.patient)}
            </TextView>
            <TextView testId={'owner'} label={systemActivityTranslationKeys.dataAuthor}>
               {practitionerNameFormatter(confidentialResource.owner)}
            </TextView>

            <ReviewRequestForm>
               {({ handleSubmit, formState }) => (
                  <>
                     <ReviewRequestAcceptButton
                        requestId={request.id}
                        grantee={request.grantee}
                        onSuccess={props.onClose}
                        handleSubmit={handleSubmit}
                     />
                     <ReviewRequestRejectButton
                        requestId={request.id}
                        grantee={request.grantee}
                        onSuccess={props.onClose}
                        handleSubmit={handleSubmit}
                     />
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </ReviewRequestForm>
         </StyledFlex>
      </Modal>
   );
};
